import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from '../shared.module';
import { catchError, map } from 'rxjs/operators';

//SERVICES
import { ConfigService } from '../services/config.service';
//MODELS
import { Observable, of, Subscriber } from 'rxjs';
import { CompassApiResponse } from '../models/compass-api-response.interface';
import { CompassApiStatusEnum } from '../models/compass-api-status-enum';
import { Booking } from '../models/booking.interface';
import { CompassApiGetResults } from '../models/compass-api-get-results.interface';
import { BookingAdditionalInfoForm } from '../models/booking-additional-info-form.interface';


@Injectable({providedIn: SharedModule})
export class CompassAPIBookingAdditionalInfoFormService {

	public params = new URLSearchParams();
	public config: any;
	public baseUrl: string;

	constructor(
		private httpClient: HttpClient,
		private _configService: ConfigService
	) { 

		this.config = this._configService.getCompassApi();
		//console.log('this.config:', this.config);
		this.baseUrl = this.config.baseUrl + 'bookingadditionalinfoforms';
	}


	/**
	 * Get Booking Additional Info Form
     * previously: Post-Purchase Variants
	 * @param bookingId 
	 * @returns 
	*/
	public getBookingAdditionalInfoForm (bookingId: string){
		let url = new URL(this.baseUrl + '/' + bookingId);
		//url.searchParams.append('bookingId', String(bookingId));
        //console.log('API.getBookingAdditionalInfoForm().url', String(url));

		return this.httpClient
			.get(String(url), { headers: this.config.headers })
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.getBookingAdditionalInfoForm.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					const result: BookingAdditionalInfoForm = res.result;
					return result;
				} else {
					return null;
				}
			}));
	}




	/**
	 * Put (update) ADditional info
	 * @param data:any
	 * @returns 
	*/
	public submitInfo (data: any): Observable<any>{
		let url = this.baseUrl + '/' + data.id + '/submit',
			body = data,
			options = { 
				headers: this.config.headers,
			};
		//console.log('putProducts().url:', url);
		// console.log('putProducts().body', body);
		// console.log('putProducts().options', options);

		return this.httpClient
			.put(url, body, options)
			.pipe(
				catchError(err => of({"error": err.error}))
			)
			.pipe(map((res: CompassApiResponse) => {
				//console.log('API.putProducts.res:', res);
				if(res.status == CompassApiStatusEnum.ok) {
					return res.result;
				} else { 
					return res;
				}
			}));
	}

}